import { Link, useSearchParams } from "react-router-dom";
import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";

import { getScenariosCategories } from "~/data/dashboard/dashboard.service";

export const scenariosCategoriesQuery = queryOptions({
  queryKey: ["scenarios_categories"],
  queryFn: () => getScenariosCategories(),
  staleTime: Infinity,
});

export function ScenarioCategoriesList() {
  const { data } = useSuspenseQuery(scenariosCategoriesQuery);
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedCategory = searchParams.get("category_id");

  return (
    <section className="grid grid-cols-2 md:grid-cols-3 gap-4 p-5">
      {data.categories.map((category) => {
        const search = new URLSearchParams(searchParams);
        search.set("category_id", category.id);

        return (
          <Link
            key={category.id}
            to={`?${search}`}
            replace={!!selectedCategory}
            className="flex px-4 py-5 rounded-[20px] h-[150px] border-l-[6px] border-l-alternative-2 bg-[#f9f9f9] bg-cover bg-center bg-no-repeat"
            style={{
              backgroundImage:
                selectedCategory === category.id
                  ? `linear-gradient(90deg, rgba(0, 0, 0, 0.80) 0%, rgba(0, 0, 0, 0.00) 100%), url('${
                      import.meta.env.VITE_API_URL + category.banner_url
                    }')`
                  : undefined,
            }}
            onClick={() => setSearchParams((s) => new URLSearchParams(s))}
          >
            <div className="flex flex-col items-start">
              <h4 className="text-alternative-1 font-semibold text-sm uppercase">
                {category.name}
              </h4>
              <p
                className={`${
                  selectedCategory === category.id
                    ? "text-white"
                    : "text-gray-600"
                }`}
              >
                <span
                  className={`font-normal text-xs ${
                    selectedCategory === category.id
                      ? "text-white"
                      : "text-black"
                  }`}
                >
                  <span className="font-semibold">{category.user_tests}</span>
                </span>{" "}
                {plural(category.user_tests, {
                  one: "Prática realizada",
                  other: "Práticas realizadas",
                })}
              </p>
            </div>
          </Link>
        );
      })}
    </section>
  );
}

function plural(
  n: number,
  messages: Partial<Record<Intl.LDMLPluralRule, string>>
) {
  const p = new Intl.PluralRules("pt-BR");
  return messages[p.select(n)];
}
